import { create } from 'zustand';
import type { User } from '../types';

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
  setUser: (user: User | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  /** Simulates a plan upgrade — replaces real payment in MVP */
  upgradePlan: (plan: User['plan']) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  error: null,
  setUser: (user) => set({ user, loading: false }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  upgradePlan: (plan) =>
    set((state) => ({
      user: state.user ? { ...state.user, plan } : state.user,
    })),
}));
